/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GroupingRuleCostAnomalyThreshold {
    getFixupPrototypeFunction() { return GroupingRuleCostAnomalyThreshold.fixupPrototype; }

    static newInstance(model: Partial<GroupingRuleCostAnomalyThreshold>): GroupingRuleCostAnomalyThreshold {
        let obj = Object.assign(new GroupingRuleCostAnomalyThreshold(), model);
        GroupingRuleCostAnomalyThreshold.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GroupingRuleCostAnomalyThreshold>): GroupingRuleCostAnomalyThreshold {
        if (!model) return null;
        return GroupingRuleCostAnomalyThreshold.newInstance(<GroupingRuleCostAnomalyThreshold> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GroupingRuleCostAnomalyThreshold) {
        if (!obj) return;

        models.GroupingRuleCostAnomalyThreshold.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GroupingRuleCostAnomalyThreshold): boolean {
        Object.setPrototypeOf(obj, GroupingRuleCostAnomalyThreshold.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.minimum_cost_spend === undefined) {
            this.minimum_cost_spend = 0;
        }
        if (this.impact) {
            models.GroupingRuleCostAnomalyImpact.fixupPrototype(this.impact);
        }
    }

    /**
     * Cost impact conditions to trigger anomaly detection for this dimension
     */
    impact: models.GroupingRuleCostAnomalyImpact;

    /**
     * Minimum cost spend to trigger anomaly detection for this Grouping Rule
     */
    minimum_cost_spend: number;

    /**
     * Operator to combine the threshold conditions
     */
    op: models.CostAnomalyThresholdOperator;

}
